import React from 'react'
export const EnglishCanvas = ({ user, score, type, boothDetails, isScoreShow, title}) => {
    if (type && type == 'karyakarta') {
        return (
            <div className="cert_center" id="generate_canvas_div">
                <div className="cert_content_position">
                    <img src="/assets/images/kamal.png" className="kamal"/>
                    <div className="cert_content">
                        <img src="/assets/images/modi.png" alt="" />

                        <h5 className="nm_can_name">
                            Narendra <span>Modi</span>
                        </h5>

                        <h2 className="cong_canvas">Vande Mataram</h2>
                        <h3 >
                            <span className="en_dear">Dear </span><span className="volnt_name">{user}</span>
                        </h3>
                        <h6 className="volnt_g_eff">You have made booth number <span className="volnt_g_eff">{boothDetails.boothno}</span> of <span className="volnt_g_eff">{boothDetails.state}</span>.<br/>
                        Vidhan Sabha constituency in <span className="volnt_g_eff">{boothDetails.vsabha}</span> proud <br/>by participating in the
                        </h6>
                       
                        <h2 className="mkb_qz_h2">{title || "‘Mann Ki Baat Quiz’"}</h2>
                        {isScoreShow && <p className="yougot">
                            You got{" "}<span>{score}</span> answers correct
                        </p>}
                        <h5 className="certi_canvs_h52">Thanks for taking the quiz</h5>
                        <h4 className="app_txt">NaMo App</h4>
                    </div>
                </div>
            </div>
        )
    }else{
        return (
            <div className="cert_center" id="generate_canvas_div">
                <div className="cert_content_position">
                    <div className="cert_content">
                        <img src="/assets/images/modi.png" alt="" />

                        <h5 className="nm_can_name">
                            Narendra <span>Modi</span>
                        </h5>

                        <h2 className="cong_canvas"><strong>Congratulations</strong></h2>
                        <h3 className="volnt_name">
                            {user}
                        </h3>
                        <h6 className="volnt_g_eff">Great effort...</h6>
                        {isScoreShow && <p className="yougot">You got{" "}
                            <span>{score}</span> answers correct in the
                        </p>}
                        <h2 className="mkb_qz_h2">{title || "‘Mann Ki Baat Quiz’"}</h2>
                        <h5 className="certi_canvs_h5">Your participation matters!</h5>
                        <h5 className="certi_canvs_h52">Thanks for taking the quiz</h5>
                        <h4 className="app_txt">NaMo App</h4>
                    </div>
                </div>
            </div>
        )
    }
    
}